import { TrendingUp, Users, Award, Clock } from 'lucide-react';

export const Stats = () => {
  const stats = [
    { icon: Users, value: '500+', label: 'Spokojených klientů' },
    { icon: TrendingUp, value: '8 let', label: 'Zkušeností' },
    { icon: Award, value: '12', label: 'Finančních nástrojů' },
    { icon: Clock, value: '15 min', label: 'Konzultace ZDARMA' },
  ];

  return (
    <section className="py-12 border-y border-white/10" data-testid="stats-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="text-center">
                <div className="w-12 h-12 rounded-xl bg-gold/10 flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-6 h-6 text-gold" />
                </div>
                <p className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</p>
                <p className="text-gray-400 text-sm">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
